// Accordion Group JavaScript - Show/Hide Plus/Minus Icons
document.addEventListener("DOMContentLoaded", function () {
  const accordionGroups = document.querySelectorAll(".accordion-group");

  accordionGroups.forEach((group) => {
    const accordions = group.querySelectorAll("[data-collapsible]");

    accordions.forEach((accordion) => {
      const iconWrapper = accordion.querySelector(".accordion__icon");

      if (iconWrapper) {
        const svgIcons = iconWrapper.querySelectorAll("svg");
        const plusIcon = svgIcons[0]; // First SVG (plus icon)
        const minusIcon = svgIcons[1]; // Second SVG (minus icon)

        // Function to update icon visibility
        function updateIconVisibility() {
          const isOpen = accordion.getAttribute("open") === "true";

          if (plusIcon && minusIcon) {
            if (isOpen) {
              // Show minus, hide plus
              plusIcon.style.display = "none";
              minusIcon.style.display = "block";
            } else {
              // Show plus, hide minus
              plusIcon.style.display = "block";
              minusIcon.style.display = "none";
            }
          }
        }

        // Set initial state
        updateIconVisibility();

        // Listen for clicks on the trigger
        const trigger = accordion.querySelector("[data-collapsible-trigger]");
        if (trigger) {
          trigger.addEventListener("click", function (e) {
            // Small delay to allow the CollapsibleElements to update the open attribute
            setTimeout(() => {
              updateIconVisibility();
            }, 10);
          });
        }

        // Also listen for attribute changes (in case other code modifies the open attribute)
        const observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (
              mutation.type === "attributes" &&
              mutation.attributeName === "open"
            ) {
              updateIconVisibility();
            }
          });
        });

        observer.observe(accordion, {
          attributes: true,
          attributeFilter: ["open"],
        });
      }
    });
  });
});

// Handle theme editor updates
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener("shopify:section:load", function (event) {
    if (event.target.querySelector(".accordion-group")) {
      // Re-initialize when section is loaded in theme editor
      setTimeout(() => {
        const accordionGroup = event.target.querySelector(".accordion-group");
        if (accordionGroup) {
          const accordions =
            accordionGroup.querySelectorAll("[data-collapsible]");
          accordions.forEach((accordion) => {
            const iconWrapper = accordion.querySelector(".accordion__icon");

            if (iconWrapper) {
              const svgIcons = iconWrapper.querySelectorAll("svg");
              const plusIcon = svgIcons[0];
              const minusIcon = svgIcons[1];

              const isOpen = accordion.getAttribute("open") === "true";

              if (plusIcon && minusIcon) {
                if (isOpen) {
                  plusIcon.style.display = "none";
                  minusIcon.style.display = "block";
                } else {
                  plusIcon.style.display = "block";
                  minusIcon.style.display = "none";
                }
              }
            }
          });
        }
      }, 100);
    }
  });
}
